<div class="export-wallet">
  @if (currentStep() === "password" && hasMnemonic()) {
    <div
      class="export-wallet__password-step flex column align-items-center gap-24 full-width"
    >
      <div class="flex column align-items-center gap-8 text-align-center">
        <span class="typo-title-3">Confirm Password</span>
        <span class="typo-text-2 text-medium">
          Enter your wallet password to reveal the seed phrase.
        </span>
      </div>
      <div class="export-wallet__password-form flex column gap-16 full-width">
        <kc-input
          [infoLabel]="{ label: 'Password' }"
          [type]="'password'"
          [placeholder]="'Enter your password'"
          [isValid]="!passwordError()"
          [(ngModel)]="password"
          (ngModelChange)="onPasswordInput()"
          (keyup.enter)="onVerifyPassword()"
        />
        @if (passwordError()) {
          <span class="kc-input-error-text">{{ passwordError() }}</span>
        }
        <kc-button
          [variant]="'primary'"
          [text]="'Continue'"
          [isDisabled]="isVerifying() || !password().trim()"
          (buttonClick)="onVerifyPassword()"
        />
      </div>
    </div>
  } @else {
    <div
      class="export-wallet__content flex column align-items-center gap-24 full-width"
    >
      <div class="flex column align-items-center gap-4">
        <span class="typo-title-3 p-4">Seed Phrase</span>
        @if (hasMnemonic()) {
          <span class="typo-text-2 text-medium text-align-center"
            >This seed phrase is the only way to recover your wallet. Do NOT
            share it with anyone.</span
          >
        }
      </div>
      @if (hasMnemonic()) {
        <div class="seed-container">
          @for (item of seedWords(); track $index) {
            <app-seed-phrase-word
              class="seed-container__word"
              [idx]="$index + 1"
              [word]="item"
            />
          }
        </div>
      } @else {
        <div class="flex column align-items-center gap-8">
          <span class="typo-text-2 text-align-center"
            >This wallet was created without a seed phrase (private key only) or
            the seed phrase is unavailable.</span
          >
        </div>
      }
      @if (hasMnemonic()) {
        <div class="flex full-width justify-content-between">
          <kc-button
            [variant]="'secondary'"
            [suffixIcon]="'icon-copy'"
            [text]="'Copy'"
            (buttonClick)="copySeedToClipboard()"
          />
          <kc-button
            [variant]="'primary'"
            [suffixIcon]="'icon-download'"
            [text]="'Download .txt'"
            (buttonClick)="downloadSeedAsTxt()"
          />
        </div>
      }
    </div>
  }
</div>
